interface SiteBaseProps {
  title: string;
  region?: string;
  default?: true;
}

interface SiteWithLanguagesProps extends SiteBaseProps {
  languages: {
    title: string;
    uri: string;
  }[];
}

interface SiteBasicProps extends SiteBaseProps {
  uri: string;
}

export type Site = SiteWithLanguagesProps | SiteBasicProps;

const sites: Site[] = [
  {
    title: theme.strings.geo.regions.unitedStatesOfAmerica,
    region: 'us',
    languages: [
      {
        title: `${theme.strings.geo.regions.unitedStatesOfAmerica} (${theme.strings.geo.languages.english})`,
        uri: 'rains-us.myshopify.com',
      },
      {
        title: `${theme.strings.geo.regions.unitedStatesOfAmerica} (${theme.strings.geo.languages.spanish})`,
        uri: 'rains-us.myshopify.com/es',
      },
    ],
  },
  {
    title: theme.strings.geo.regions.denmark,
    uri: 'rains-da.myshopify.com',
    region: 'dk',
  },
  {
    title: theme.strings.geo.regions.greatBritain,
    uri: 'rains-uk.myshopify.com',
    region: 'gb',
  },
  {
    title: theme.strings.geo.regions.germany,
    uri: 'rains-de.myshopify.com',
    region: 'de',
  },
  {
    title: theme.strings.geo.regions.france,
    uri: 'rains-fr.myshopify.com',
    region: 'fr',
  },
  {
    title: theme.strings.geo.regions.china,
    uri: 'rains.world.tmall.com',
    region: 'cn',
  },
  {
    title: theme.strings.geo.regions.netherlands,
    uri: 'rains-nl.myshopify.com',
    region: 'nl',
  },
  {
    title: theme.strings.geo.regions.italy,
    uri: 'rains-it.myshopify.com',
    region: 'it',
  },
  {
    title: theme.strings.geo.regions.spain,
    uri: 'rains-es.myshopify.com',
    region: 'es',
  },
  {
    title: theme.strings.geo.regions.sweden,
    uri: 'rains-se.myshopify.com',
    region: 'se',
  },
  {
    title: theme.strings.geo.regions.canada,
    region: 'ca',
    languages: [
      {
        title: `${theme.strings.geo.regions.canada} (${theme.strings.geo.languages.english})`,
        uri: 'rains-ca.myshopify.com',
      },
      {
        title: `${theme.strings.geo.regions.canada} (${theme.strings.geo.languages.french})`,
        uri: 'rains-ca.myshopify.com/fr',
      },
    ],
  },
  {
    title: theme.strings.geo.regions.australia,
    uri: 'rains-au.myshopify.com',
    region: 'au',
  },
  {
    title: theme.strings.geo.regions.newZealand,
    uri: 'rains-au.myshopify.com',
    region: 'nz',
  },
  {
    title: theme.strings.geo.regions.austria,
    uri: 'rains-de.myshopify.com',
    region: 'at',
  },
  {
    title: theme.strings.geo.regions.poland,
    uri: 'rains-dk.myshopify.com/en-pl',
    region: 'pl',
  },
  {
    title: theme.strings.geo.regions.switzerland,
    uri: 'rains-dk.myshopify.com/en-ch',
    region: 'ch',
  },
  {
    title: theme.strings.geo.regions.singapore,
    uri: 'rains-dk.myshopify.com/en-sg',
    region: 'sg',
  },
  {
    title: theme.strings.geo.regions.taiwan,
    uri: 'rains-dk.myshopify.com/en-tw',
    region: 'tw',
  },
  {
    title: theme.strings.geo.regions.korea,
    uri: 'rains-ko.myshopify.com',
    region: 'kr',
  },
  {
    title: theme.strings.geo.regions.international,
    uri: 'rains-dk.myshopify.com',
    default: true,
  },
  {
    title: theme.strings.geo.regions.staging,
    uri: 'rains-staging.myshopify.com',
  },
];

export default sites;
